import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

const ZenModeContext = createContext({
  isZenMode: false,
  toggleZenMode: () => {},
  setZenMode: () => {},
});

export const ZenModeProvider = ({ children }) => {
  const [isZenMode, setIsZenMode] = useState(false);

  const toggleZenMode = useCallback(() => {
    setIsZenMode((prev) => !prev);
  }, []);

  const setZenMode = useCallback((val) => {
    setIsZenMode(Boolean(val));
  }, []);

  // Global keydown listeners for Escape / 'z' / 'Z'
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Don't trigger if user is typing in an input/textarea
      if (
        e.target.tagName === "INPUT" ||
        e.target.tagName === "TEXTAREA" ||
        e.target.isContentEditable
      ) {
        return;
      }

      if (e.key === "Escape" && isZenMode) {
        setIsZenMode(false);
      } else if ((e.key === "z" || e.key === "Z") && !e.metaKey && !e.ctrlKey && !e.altKey) {
        // Toggle zen mode
        setIsZenMode((prev) => !prev);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isZenMode]);

  return (
    <ZenModeContext.Provider value={{ isZenMode, toggleZenMode, setZenMode }}>
      {children}
    </ZenModeContext.Provider>
  );
};

export const useZenMode = () => useContext(ZenModeContext);
